<template>
  <el-dialog :visible="show" :close-on-click-modal="false" width="90%" class="h5-form" :before-close="() => $emit('close')">
    <div class="toTry">
      <div class="try-tit">免费试用</div>
      <div class="line">
        <input
          :class="[(isClick && name == '') || name == '请输入您的姓名(中文)' ? 'active_input' : '']"
          v-model="name"
          type="text"
          class="userName"
          placeholder="您的姓名"
          @focus="clearData(0)"
          @blur="onfousFun()"
        />
      </div>
      <div class="line">
        <input
          :class="[(isClick && companyName == '') || companyName == '请输入公司名称(中文)' ? 'active_input' : '']"
          v-model="companyName"
          type="text"
          class="companyName"
          placeholder="公司名称"
          @focus="clearData(1)"
          @blur="onfousFun()"
        />
      </div>
      <div class="line">
        <input
          :class="[(isClick && phoneNumber == '') || phoneNumber == '请输入您的联系方式' ? 'active_input' : '']"
          v-model="phoneNumber"
          id="mobile"
          type="text"
          class="mobile"
          placeholder="手机号码"
          @focus="clearData(2)"
          @blur="onfousFun()"
        />
      </div>

      <div class="line">
        <div class="code-box code-box-boder">
          <input
            :class="[(isClick && phoneCode == '') || phoneCode == '请输入验证码' ? 'active_input' : '']"
            v-model="phoneCode"
            maxlength="6"
            type="text"
            class="code-input form-control code no_border"
            placeholder="验证码"
            @focus="clearData(3)"
            @blur="onfousFun()"
          />
          <span
            :class="[codeName == '获取验证码' ? 'active_c1' : 'active_c']"
            class="code-btn"
            id="code-btn"
            @click="handleFetchCodeClick()"
            >{{ codeName }}</span
          >
        </div>
      </div>
      <div class="line agreement-line" v-if="userAgreement.enable">
        <label class="wrapper">
          <input type="checkbox" v-model="agreement" />
          <span>我已阅读并同意<span style="color:#1890ff;" @click.prevent="showProtocal">《隐私政策》</span></span>
        </label>
        <div v-show="showErrorTip" class="error-tip">请先阅读并同意隐私政策</div>
      </div>
      <div class="line bot-container">
        <div id="man-machine-slide"></div>
      </div>
      <div class="btn-try" :class="changeBtnBg ? 'bg_active1' : 'bg_active0'" @click="handleSendInfoBtnClick()">
        提交试用信息
      </div>
      <!-- <a name="reg-pc" :href="`https://h5.esign.cn/usercenterFront/regist?pub=${pub}`" class="btn_zc">注册体验</a> -->
    </div>

    <!-- 阅读协议 -->
    <Protocol :visible.sync="protocolVisible" :type="protocolType" />
  </el-dialog>
</template>

<script>
import formMixin from '../mixins/form.js'

export default {
  mixins: [formMixin],
  components: {
    Protocol: () => import('@/components/Protocol.vue'),
  },
  props: {
    show: Boolean,
    landingPageName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isH5: true,
      protocolVisible: false,
      protocolType: 'privacy',
      showErrorTip: false,
    }
  },
  watch: {
    show(val) {
      if (!val) this.reset()
    },
  },
  methods: {
    showProtocal() {
      this.protocolVisible = true
    },
  },
}
</script>

<style lang="less" scoped>
.h5-form {
  /deep/ .el-dialog {
    border-radius: 10px;
  }

  /deep/ .el-dialog__header {
    padding: 0;
    height: 28px;
  }

  /deep/ .el-dialog__headerbtn {
    top: 10px;
  }

  /deep/ .el-dialog__close {
    font-size: 12px;
  }

  /deep/ .el-dialog__body {
    padding: 0 0 21px;
  }

  .title {
    width: 489px;
    height: 227px;
    background-image: url(https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/banner_text.png);
    background-size: contain;
    background-repeat: no-repeat;
    margin-top: 127px;
  }

  .toTry {
    font-size: 16px;
  }

  a {
    display: block;
    text-decoration: none;
  }

  .line {
    width: 300px;
    height: 40px;
    position: relative;
    margin: 0 auto 16px;

    .form-control.code {
      width: 170px !important;
      padding-left: 20px !important;
    }

    .active_c {
      color: #ccc;

      &1 {
        color: #297acc;
      }
    }
  }

  .code-box {
    position: relative;

    .no_border {
      border: 0;
      box-shadow: none !important;

      &:focus {
        box-shadow: none;
        border-color: #fa485a;
      }
    }
  }

  .code-box-boder {
    border: 1px solid #ebebeb;
  }

  .code-btn {
    width: 113px;
    height: 40px;
    border-radius: 2px;
    position: absolute;
    text-align: right;
    right: 20px;
    top: 0;
    bottom: 0;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    line-height: 40px;

    &.disabled {
      background: #ccc;
      color: #fff;
    }
  }

  .active_input {
    border: 1px solid #e61717;
    color: #e61717;
  }

  .bg_active0 {
    background: #e61717 !important;
  }
  .bg_active1 {
    background: rgba(230, 23, 23, 0.5) !important;
  }

  input {
    font-size: 14px;
    font-family: PingFangSC-Regular;
    width: 100%;
    display: block;
    height: 40px;
    border: 1px solid #e4e4e4;
    padding: 6px 20px;
    color: #333;
    outline: 0;

    &::placeholder {
      color: #4d4d4d;
    }
  }

  .btn_zc {
    width: 300px;
    height: 20px;
    line-height: 20px;
    margin: 0 auto;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    color: #297acc;
  }

  .active_input {
    border: 1px solid #e61717;
    color: #e61717;
  }

  .try-tit {
    font-size: 18px;
    font-family: PingFangSC-Medium;
    color: #333;
    line-height: 25px;
    font-weight: 700;
    margin-bottom: 17px;
    text-align: center;
  }

  .btn-try {
    width: 300px;
    height: 42px;
    border-radius: 3px;
    margin: 0 auto 17px;
    text-align: center;
    line-height: 42px;
    font-size: 14px;
    color: #fff;
  }

  .bot-container {
    height: auto;
  }
  .agreement-line {
    height: auto;
    color: #000;
    padding-bottom: 6px;
    .wrapper {
      display: flex;
      align-items: center;
    }
    input {
      width: 14px;
      height: 14px;
      display: inline-block;
      flex-grow: 0;
    }
    span {
      font-size: 13px;
      margin-left: 6px;
    }
    a {
      display: inline-block;
      font-size: 13px;
      color: #1890ff;
    }
    .error-tip {
      font-size: 12px;
      color: red;
      position: absolute;
      bottom: -12px;
    }
  }
}
</style>

<style lang="less">
@import '../mixins/bot.less';

.h5-form {
  .bot_slide_h5(
    @slideHeight: 40px,
    @okIconColor: #37c780,
    @placeholderColor: #1a1a1a,
    @placeholderFontWeight: 400,
    @arrowSize: 14px,
    @arrowColor: #979797
  );
}
</style>
